<div style="width: 300px; margin: auto;">
  <div class="hovered-date">{{ hoveredDateLabel || ' ' }}</div>
  <mat-calendar (mouseover)="onCalendarMouseOver($event)" (mouseleave)="onCalendarMouseLeave()"></mat-calendar>
</div>
